import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modals';
import { LAUNDRY_BOOKINGS } from '../bookings';
import { LAUNDRY_SCHEDULES } from '../schedules';
import { submitResourceBooking } from './api';
import { mapDataForBackend } from './mapData';

export function useSubmitResourceBooking() {

  const { openModal } = useModal();

  const queryClient = useQueryClient();

  const { mutate, isLoading, isSuccess, isError } = useMutation(
    (data) => submitResourceBooking(mapDataForBackend(data)),
    {
      onSuccess: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'submitResourceSuccess',
          },
        });
        queryClient.invalidateQueries(LAUNDRY_BOOKINGS);
        queryClient.invalidateQueries(LAUNDRY_SCHEDULES);
      },
      onError: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'submitResourceError',
          },
        });
      },
    },
  );

  return {
    submitResourceBooking: mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
